import { useState } from 'react';

import { useGetRefuseReasons } from '../../api/getRefuseReasons';
import { dictionaryTypes } from '../../types';
import { DictionaryList } from '../DictionaryList';

import { RefuseReasonsRow } from './RefuseReasonsRow';

export const RefuseReasonsList = () => {
  const [viewMode, setViewMode] = useState<dictionaryTypes.ViewMode>('active');
  const { data, isLoading, isFetching, isError, refetch } = useGetRefuseReasons({ viewMode });
  const refuseReasons = data?.refuseReasons ?? [];

  return (
    <DictionaryList
      viewMode={viewMode}
      onViewModeChange={setViewMode}
      isLoading={isLoading}
      isFetching={isFetching}
      isError={isError}
      onRetry={refetch}
      columnLabel="Reason"
      errorText="Failed to load refuse reasons"
      emptyText={viewMode === 'archived' ? 'No archived refuse reasons' : 'No refuse reasons'}
      isEmpty={refuseReasons.length === 0}
    >
      {refuseReasons.map((refuseReason) => (
        <RefuseReasonsRow key={refuseReason._id} refuseReason={refuseReason} />
      ))}
    </DictionaryList>
  );
};
